import { render, staticRenderFns } from "./PvRightColumn.vue?vue&type=template&id=38314645&"
import script from "./PvRightColumn.vue?vue&type=script&lang=js&"
export * from "./PvRightColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports